import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

/** Indicador de carregamento (spinner). */
export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn("h-4 w-4 animate-spin", className)} aria-hidden="true" />;
}
